<div class="container">
  <h3 mat-dialog-title>ELIMINAR {{ data.toDelete }}?</h3>
  <div mat-dialog-content>
    <p>¿ESTAS SEGURO QUE DESEAS ELIMINAR A {{ data.name }}?</p>
  </div>
  <div class="mb-1" mat-dialog-actions>
    <button (click)="confirmDelete()" [mat-dialog-close]="1" color="warn" mat-flat-button>
      BORRAR
    </button>
    <button (click)="onNoClick()" mat-flat-button tabindex="-1">CANCELAR</button>
  </div>
</div>
